/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shell_Tab_ProgressInputs */

const en_us2_shell_tab_progress = /** @type {(inputs: Shell_Tab_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progress`)
};

const pt_br2_shell_tab_progress = /** @type {(inputs: Shell_Tab_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso`)
};

const es_419_shell_tab_progress = /** @type {(inputs: Shell_Tab_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progreso`)
};

const pt_pt2_shell_tab_progress = /** @type {(inputs: Shell_Tab_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso`)
};

const fr_fr2_shell_tab_progress = /** @type {(inputs: Shell_Tab_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progrès`)
};

const de_de2_shell_tab_progress = /** @type {(inputs: Shell_Tab_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortschritt`)
};

const it_it2_shell_tab_progress = /** @type {(inputs: Shell_Tab_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progressi`)
};

/**
* | output |
* | --- |
* | "Progress" |
*
* @param {Shell_Tab_ProgressInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_tab_progress = /** @type {((inputs?: Shell_Tab_ProgressInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Tab_ProgressInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_tab_progress(inputs)
	if (locale === "es-419") return es_419_shell_tab_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_tab_progress(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_tab_progress(inputs)
	if (locale === "de-DE") return de_de2_shell_tab_progress(inputs)
	if (locale === "it-IT") return it_it2_shell_tab_progress(inputs)
	return en_us2_shell_tab_progress(inputs)
});
export { shell_tab_progress as "shell.tab_progress" }